/**
 * 图表控制栏组件
 * 职责: 货币选择、时间范围选择
 * 限制: <100行
 */

import React from 'react';
import { Select, Radio, Space, DatePicker } from 'antd';
import { LineChartOutlined } from '@ant-design/icons';
import type { Dayjs } from 'dayjs';
import { CURRENCY_COLORS } from '../utils/chartConfig';

const { RangePicker } = DatePicker;
const { Option } = Select;

const ALL_CURRENCIES = ['USD', 'EUR', 'JPY', 'GBP', 'AUD', 'CAD', 'CHF', 'HKD', 'SGD', 'KRW'];

interface ChartControlsProps {
    selectedCurrencies: string[];
    onCurrenciesChange: (currencies: string[]) => void;
    timeRange: 'week' | 'month' | 'half_year' | 'year' | 'custom';
    onTimeRangeChange: (e: any) => void;
    customDateRange: [Dayjs, Dayjs];
    onDateRangeChange: (dates: [Dayjs, Dayjs] | null) => void;
}

export const ChartControls: React.FC<ChartControlsProps> = ({
    selectedCurrencies,
    onCurrenciesChange,
    timeRange,
    onTimeRangeChange,
    customDateRange,
    onDateRangeChange
}) => {
    return (
        <div style={{
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 24,
            flexWrap: 'wrap',
            gap: 16
        }}>
            <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{
                    fontSize: 16,
                    fontWeight: 600,
                    color: '#262626',
                    display: 'flex',
                    alignItems: 'center'
                }}>
                    <LineChartOutlined style={{ marginRight: 8, color: '#1890ff' }} />
                    汇率走势分析
                </div>
                <div style={{ width: 1, height: 16, backgroundColor: '#f0f0f0' }} />
                <Select
                    mode="multiple"
                    style={{ minWidth: 240 }}
                    placeholder="选择对比货币"
                    value={selectedCurrencies}
                    onChange={onCurrenciesChange}
                    maxTagCount="responsive"
                    variant="borderless"
                >
                    {ALL_CURRENCIES.map(c => (
                        <Option key={c} value={c}>
                            <Space>
                                <span style={{
                                    display: 'inline-block',
                                    width: 8,
                                    height: 8,
                                    borderRadius: '50%',
                                    backgroundColor: CURRENCY_COLORS[c] || '#ccc'
                                }} />
                                {c}
                            </Space>
                        </Option>
                    ))}
                </Select>
            </div>

            <Space size={16}>
                <Radio.Group value={timeRange} onChange={onTimeRangeChange} buttonStyle="solid">
                    <Radio.Button value="week">近7天</Radio.Button>
                    <Radio.Button value="month">近30天</Radio.Button>
                    <Radio.Button value="half_year">近半年</Radio.Button>
                    <Radio.Button value="year">近1年</Radio.Button>
                    <Radio.Button value="custom">自定义</Radio.Button>
                </Radio.Group>

                {timeRange === 'custom' && (
                    <RangePicker
                        value={customDateRange}
                        onChange={(dates) => onDateRangeChange(dates as [Dayjs, Dayjs] | null)}
                        allowClear={false}
                        style={{ width: 240 }}
                    />
                )}
            </Space>
        </div>
    );
};
